<template>
    <div class="history-back-container">
        <button 
            class="button-bordered cta--icon"
            @click="getBack"
        >g</button>
    </div>
</template>

<script setup lang="ts">
    const router = useRouter()
    const route = useRoute()

    const { locale } = useI18n();

    const getBack = () => {
        const lastRoute = useLastRoute().value

        if (lastRoute.fullPath === route.path) {
            return navigateTo(`/${locale.value}/kaleidoscope/`)
        } else {
            return router.back()
        }
    }
</script>